module.exports = __webpack_public_path__ + "img/位图(5).160756b7.png";